export default __webpack_public_path__ + "static/media/close.c1404c03.svg";